export default "__VITE_ASSET__BbGN69kJ__"